import { useMemo } from 'react';

import { hasItem, makeTab } from '@sravni/ugc/lib/specialOffers/helpers';
import {
  ACTIONS,
  BUSINESS_OFFERS,
  COMMON_OFFERS,
  INSURANCE_OFFERS,
  INSURANCE_OFFERS_LIST,
  OFFERS_TABS_DEFAULT_ORDER,
} from '@sravni/ugc/lib/specialOffers/lists';
import { PRODUCT_TAG_TO_SPECIAL_OFFERS_TABS_MAP } from '@sravni/ugc/lib/specialOffers/productTagToTab';
import { InsuranceOffersType, Tab } from '@sravni/ugc/lib/specialOffers/types';

import { useIsUserLogged } from './users';

interface IProps {
  productTags?: string[];
  rubric?: string;
  tags?: string[];
}

export const useGenerateTabsForSpecialOffers = ({ productTags, rubric, tags }: IProps): Tab[] => {
  const isUserLogged = useIsUserLogged();

  const tabs = useMemo(() => {
    const tabList = [];

    if (tags?.includes('Партнёрский материал')) {
      return tabList;
    }

    if (productTags.length) {
      productTags.forEach((tag) => {
        if (isUserLogged && ['osago', 'avtokredity'].includes(tag)) {
          tabList.push(makeTab(ACTIONS.osago));
        }

        const tab = PRODUCT_TAG_TO_SPECIAL_OFFERS_TABS_MAP[tag];

        if (!tab) return;
        tabList.push(...tab);

        if (hasItem(INSURANCE_OFFERS_LIST, makeTab(tag as InsuranceOffersType))) {
          tabList.push(...INSURANCE_OFFERS_LIST);
        }
      });
    } else {
      if (isUserLogged && ['strahovki', 'auto'].includes(rubric)) {
        tabList.push(makeTab(ACTIONS.osago));
      }
      if (rubric === 'nedvizhimost') {
        tabList.push(makeTab(COMMON_OFFERS.mortgage));
      } else if (rubric === 'biznes') {
        tabList.push(makeTab(BUSINESS_OFFERS.biznesRegistration));
      } else if (rubric === 'vklady') {
        tabList.push(makeTab(COMMON_OFFERS.savings));
      } else if (rubric === 'investicii') {
        tabList.push(makeTab(COMMON_OFFERS.brokerskoeObsluzhivanie));
      } else if (rubric === 'karty') {
        tabList.push(...PRODUCT_TAG_TO_SPECIAL_OFFERS_TABS_MAP['karty']);
      } else if (rubric === 'kredity') {
        tabList.push(...PRODUCT_TAG_TO_SPECIAL_OFFERS_TABS_MAP['kredity']);
      } else if (['strahovki', 'auto'].includes(rubric)) {
        tabList.push(makeTab(INSURANCE_OFFERS.insuranceOsago));
      }
    }

    tabList.push(...OFFERS_TABS_DEFAULT_ORDER);

    return tabList.reduce((acc, tab) => (hasItem(acc, tab) ? acc : [...acc, tab]), []);
  }, [isUserLogged, productTags, rubric, tags]);

  return tabs;
};
